import styled from 'styled-components';

import ClockFillIcon from 'assets/images/icons/clock-fill.svg?react';
import ExclamationCircleFillIcon from 'assets/images/icons/exclamation-circle-fill.svg?react';
import theme from 'styles/theme';

export const ClockFillIconStyled = styled(ClockFillIcon)`
  color: ${theme.colors.hostfullyYellow};
`;

export const ExclamationCircleFillIconStyled = styled(
  ExclamationCircleFillIcon,
)`
  color: ${theme.colors.hostfullyOrange};
`;
